import logo from './logo.svg';
import { useEffect } from 'react';
import './App.css';
import { generateToken, messaging } from './notification/firebase';
import {onMessage} from "firebase/messaging"
function App() {
  
  const getOrCreateUserId = () => {
    let userId = localStorage.getItem("userIdtoken");
  
    if (!userId) {
      userId = crypto.randomUUID(); // browser-native GUID
      localStorage.setItem("userIdtoken", userId);
    }
  
    return userId;
  };

  useEffect(() => {
    // generateToken("user_123");
    const userId = getOrCreateUserId(); // 👈 key step

    generateToken(userId);
  
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground: ', payload);

      const title = payload.data?.title || "New Notification";
      const options = {
        body: payload.data?.body || "",
        icon: payload.data?.image || payload.data?.icon || "/logo192.png",
      };

      // Check if permission is granted and show native notification
      if (Notification.permission === "granted") {
        const notification = new Notification(title, options);

        // Click handler to redirect in current window
        notification.onclick = (event) => {
          event.preventDefault();
          window.focus();
          const targetUrl = payload.data?.url || "/";
          window.location.href = targetUrl;
        };
      }
    });
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
